<!--
        Las paginas para administrar Conectores
-->

<div class="page" id="dashboards-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">dashboards</div>
            <div class="tabs">
                <a class="tab" href="#dashboards?estado=A">Activos</a>
                <a class="tab" href="#dashboards?estado=I">Inactivos</a>
                <a class="tab" href="#dashboards?estado=X">Eliminados</a>
                <a class="tab" href="#?estado=*">Todos</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#conector?id=nuevo">Agregar un nuevo tablero</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section current" id="dashboards">
                <h2>message</h2>
                <a href="#" v-on:click="clicaba">click me !</a>
                <div class="list-content"></div>
            </div>
        </div>
    </div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#dashboards-collection-page").DashboardsCollectionPage("#dashboards") ;
  console.log("DONE: installed DashboardsCollectionPage to hash '#dashboards'")
})
</script>
